import { render, staticRenderFns } from "./AssignContractAddFiducia.vue?vue&type=template&id=7b9a31fa&"
import script from "./AssignContractAddFiducia.vue?vue&type=script&lang=js&"
export * from "./AssignContractAddFiducia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports